import axios from '@/axios';

const RESOURCE_NAME = '/projects-tasks';

export default {
    getList(projectId, data) {
        return axios.post(`${RESOURCE_NAME}/get-list?project_id=${projectId}`, data);
    },

    save(projectId, data) {
        return axios.post(`${RESOURCE_NAME}/save?project_id=${projectId}`, data);
    },

    getStagesData(projectId, data) {
        return axios.post(`${RESOURCE_NAME}/get-stages-data?project_id=${projectId}`, data);
    },

    getStageTasks(projectId, status, lastLinkId, data) {
        return axios.get(`${RESOURCE_NAME}/get-stage-tasks?project_id=${projectId}&status=${status}&last_link_id=${lastLinkId}`, data);
    },

    saveStageTasks(projectId, data) {
        return axios.post(`${RESOURCE_NAME}/save-stage-tasks?project_id=${projectId}`, data);
    },

    getTaskData(taskId) {
        return axios.get(`${RESOURCE_NAME}/get-task-data?task_id=${taskId}`);
    },

    getTaskPlateData(taskId) {
        return axios.get(`${RESOURCE_NAME}/get-task-plate-data?task_id=${taskId}`);
    },

    updateTask(taskId, data) {
        return axios.post(`${RESOURCE_NAME}/update-task?task_id=${taskId}`, data);
    },

    addComment(taskId, data) {
        return axios.post(`${RESOURCE_NAME}/add-comment?task_id=${taskId}`, data);
    },

    updateComment(commentId, data) {
        return axios.post(`${RESOURCE_NAME}/update-comment?comment_id=${commentId}`, data);
    },

    deleteComment(commentId) {
        return axios.post(`${RESOURCE_NAME}/delete-comment?comment_id=${commentId}`);
    },

    getActivities(taskId) {
        return axios.get(`${RESOURCE_NAME}/get-activities?task_id=${taskId}`);
    },

    getFiles(taskId) {
        return axios.get(`${RESOURCE_NAME}/get-files?task_id=${taskId}`);
    },

    addFiles(taskId, data) {
        return axios.post(`${RESOURCE_NAME}/add-files?task_id=${taskId}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },

    downloadFile(id) {
        return axios.get(`${RESOURCE_NAME}/download-file?file_id=${id}`, {
            responseType: 'blob',
        })
    },

    addWatcher(taskId, data) {
        return axios.post(`${RESOURCE_NAME}/add-watcher?task_id=${taskId}`, data);
    },

    removeWatcher(taskId, data) {
        return axios.post(`${RESOURCE_NAME}/remove-watcher?task_id=${taskId}`, data);
    },

    getWatchers(taskId) {
        return axios.get(`${RESOURCE_NAME}/get-watchers?task_id=${taskId}`);
    },

    deleteTasks(data) {
        return axios.post(`${RESOURCE_NAME}/delete-tasks`, data);
    },
}
